angular.module('leanlaw').controller('ClientMatterRevenueSidebarCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts) {
  $scope.filter = {
    include: {}
  };
  $scope.filter.include.matters = false;
  $scope.filter.include.detail = true;
  $scope.filter.include.norevenue = false;

  // Fires immediately on filter creation
  $scope.$watch("filter", () => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);

  // $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
}]);